import React from "react";
import { mediaUrl } from "@/lib/api";

export const PageCover = ({ image, overline, title, testId }) => (
  <section className="relative h-[46vh] min-h-[320px] overflow-hidden" data-testid={testId}>
    {image ? (
      <img src={mediaUrl(image) || undefined} alt="" className="absolute inset-0 w-full h-full object-cover" />
    ) : (
      <div className="absolute inset-0 bg-[#0c0c0c]" />
    )}
    <div className="absolute inset-0 bg-black/70" />
    <div className="relative h-full max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-12 md:pb-16">
      <p className="overline reveal">{overline}</p>
      <h1 className="reveal font-serif text-4xl sm:text-6xl text-white mt-4" style={{ animationDelay: "0.15s" }}>{title}</h1>
      <div className="gold-line mt-7 w-40" />
    </div>
  </section>
);

export default PageCover;
